/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import styles from './effortApproval.module.scss';
import NoDataFound from '../../../../Assets/images/svg/dar_no_new_file.svg';
import MagnifyingGlass from '../../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../Dashboard/Efforts/scopeDataGrid';
import dayjs from 'dayjs';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';
import { AuthContext } from '../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../Constants/modules';
import DealSummaryCard from '../summaryCard';
import DealPending from '../../../../Assets/images/svg/dar_pending.svg';
import DealApproved from '../../../../Assets/images/svg/dar_achieved.svg';
import DealRejected from '../../../../Assets/images/svg/dar_rejected.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import UseAxios from '../../../../Api/http/http';
import { getEffortApproverDetails } from '../../../../Api/request/approval';
import { Tooltip } from '@mui/material';

const EffortApproval = () => {
  const [rows, setRows] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [effortCount, setEffortCount] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const navigate = useNavigate();

  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const dealSummary = [
    {
      id: 1,
      heading: 'Deals Pending',
      value: effortCount.pending,
      image: DealPending,
      status: 'Pending',
    },
    {
      id: 2,
      heading: 'Deals Approved',
      value: effortCount.approved,
      image: DealApproved,
      status: 'Approved',
    },
    {
      id: 3,
      heading: 'Deals Rejected',
      value: effortCount.rejected,
      image: DealRejected,
      status: 'Rejected',
    },
  ];
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const status = queryParams.get('status');

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const fetchApprovalDetails = async () => {
    // API call to fetch effort approval details
    const roleId = userProfile?.roleDetails?.map(role => role.role_id).join(',') || '';
    try {
      const response = await UseAxios(getEffortApproverDetails(roleId, status));
      setEffortCount(response.data);
      const transformedRows = response?.data?.result.map(data => ({
        ...data,
        id: data.approvalId,
        status: capitalizeFirstLetter(data.status),
        submittedOn: data.submittedOn ? dayjs(data.submittedOn).format('MMM D, YYYY | HH:mm') : '-'
      })) || [];
      setRows(transformedRows);
    } catch (error) {
      console.error('Error fetching dealName details:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  useEffect(() => {
    fetchApprovalDetails();
  }, [status]);


  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [rows]);

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };


  const filteredRows = searchText
    ? rows.filter((row) =>
      Object.values(row).some((value) =>
        (value ? value.toString() : '').toLowerCase().includes(searchText),
      ),
    )
    : rows;

  const handleView = (id) => {
    navigate(`/deal-transition/dashboard/efforts?id=${id}`, {
      state: {
        selectedEffortsTab: 'Summary',
        isApprovalFlow: true,
      },
    });
  };

  const columns = [
    {
      field: 'dealName',
      headerName: 'Deal Name',
      minWidth: 300,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'dealEfforts',
      headerName: 'Deal Efforts',
      minWidth: 130,
      flex: 0.4,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        <label>{`${params.row.dealEfforts || 0} Man Days`}</label>,
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 105,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) =>
        <label className={`${styles.dealStatus} ${styles[params.row.status]}`}>
          {params.row.status}
        </label>,
    },
    {
      field: 'vertical',
      headerName: 'Vertical',
      minWidth: 140,
      flex: 0.4,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'submittedBy',
      headerName: 'Submitted By',
      minWidth: 150,
      flex: 0.4,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'submittedOn',
      headerName: 'Submitted On',
      minWidth: 160,
      flex: 0.5,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      headerName: 'Actions',
      headerClassName: styles.actionColumn,
      cellClassName: styles.actionCell,
      maxWidth: 80,
      renderCell: (params) => (
        <div className={styles.mobileActionIcons}>
        <Tooltip
           title='You do not have permission to view this page, kindly contact the administrator'
           classes={{ tooltip: styles['effort-approval-tooltip'] }}
           disableHoverListener={hasAccess('read')}
         >
          <Tooltip>
          <button
            className={styles.dealViewBtn}
            aria-label="View"
            onClick={() => handleView(params.row.dealId)}
            disabled={!hasAccess('read')}
          >
          View
          </button>
         </Tooltip>
       </Tooltip>
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
    columns[5].field,
  ];

  return (
    <div className={styles.effortApprovalOuterDiv}>
      <div className={styles.effortApprovalHeader}>
        <div className={styles.effortApprovalMainText}>Deals Efforts Approval</div>
      </div>
    <div className={styles.effortApprovalMainDiv}>
      {!status && (
        <>
          <div className={styles.effortApprovalTitle}>Deals Efforts Approval Summary</div>
          <DealSummaryCard dealSummary={dealSummary}/>
        </>
      )}
      <div className={`${styles.effortApprovalSummaryDiv} ${status ? styles.effortApprovalList : ''}`}>
        <div className={styles.effortApprovalGridMain}>
          <span>Lists of Deals</span>
          <div className={styles.effortApprovalSearchAdd}>
            <div className={styles.effortApprovalSearch}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="dealName-cost-search-input"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
        <div className={styles.effortApprovalGrid}>
          <DataGridComponent
            dataRows={filteredRows}
            dataColumns={columns}
            pageSize={10}
            isEdit={setRows}
            isFilteredRows={filteredRows}
            sortFilterColumns={sortFilterColumns}
            onRowSelectionChange={() => {}}
            checkboxDisabled={false}
            rowHeight={150}
            noDataImage={NoDataFound}
            noDataTitle="No records found."
            noDataSubTitle=""
            hideSeparator={true}
            dataGridCss={styles.dataGrid}
            getRowHeight={() => 'auto'}
          />
        </div>
      </div>
    </div>
    </div>
  );
};

export default EffortApproval;
